export default "__VITE_ASSET__DPDRmunu__"